import { cva } from 'class-variance-authority';
export const getHeadingClasses = cva('', {
    variants: {
        color: {
            inherit: '',
            foreground: 'text-primary',
            quiet: 'text-secondary',
            quieter: 'text-tertiary',
            inverse: 'text-inverse',
            light: 'text-light',
            dark: 'text-dark',
        },
        size: {
            large: 'text-4xl',
            default: 'text-2xl',
            small: 'text-xl',
            tiny: 'text-lg',
        },
        family: { sans: 'font-sans', mono: 'font-mono' },
        weight: { normal: 'font-normal', medium: 'font-medium', bold: 'font-bold' },
        align: { left: 'text-left', center: 'text-center', right: 'text-right' },
    },
    defaultVariants: {
        color: 'inherit',
        family: 'sans',
        size: 'default',
        weight: 'normal',
        align: 'left',
    },
});
//# sourceMappingURL=classes.js.map